import { useState } from "react";
import FormButton from "./FormButton";

export default function FormDropdown({ defOption, hasButton=false, buttonText, buttonAction, hasLabel=false, label, id, _value, list, onChangeAction, editFlag=true }) {
  // const [selectValue, setSelectValue] = useState("");
  return (
    <div className={hasButton ? "dashboardForm_section_withBtn" :"dashboardForm_section"}>
        {hasLabel ? <label htmlFor={id}>{label}</label> : null}
        {editFlag ? <select
          id={id}
          value={_value}
          className='dashboardForm_section_select'
          onChange={onChangeAction}>
          <option value={""} disabled hidden>{defOption}</option>
          {list.map((val, inx)=>{
            var value;
            if((val.name===null||val.name===undefined)&&
                (val.address===null||val.address===undefined)&&
                (val.city===null||val.city===undefined)
              ){
              value = val;
            }
            else if(val.name!==null&&val.name!==undefined){
              value = val.name;
            }
            else if(val.address!==null&&val.address!==undefined&&val.city!==null&&val.city!==undefined){
              value = `${val?.address}, ${val?.city}`;
            }
            else{
              value = `אפשרות מס' ${inx}`;
            }
            return <option key={`fromDropdown_option_${inx}_label_${label}`} value={value}>{value}</option>
          })}
        </select> : 
        <h3>{_value}</h3>}
        {hasButton ? <FormButton disabled={false} type={"button"} text={buttonText} action={()=>{buttonAction()}}/> : null}
    </div>
  )
}
